import {Permission} from '../../../types/permission-group/permission';
import {ISelectItem} from '../../common/aur-select-dropdown/types';
import {ItemType} from './tabs/AddClientInfo';

export enum TeamMemberInfoFormInputKey {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  isActive = 'isActive',
  isBillable = 'isBillable',
  isLimitIp = 'isLimitIp',
  ipAddressList = 'ipAddressList',
  workspaces = 'workspace',
  project = 'project',
}

export enum CustomIndexInfoFormInputKey {
  customIndex = 'customIndex',
  savedSearch = 'Saved Search',
}
export const CUSTOM_INDEX_NAME_MAX_LENGTH = 50;

export enum UserRecordsFilter {
  ALL = 'All',
  USER_RECORDS_WITH_ERROR = 'Errors',
  USER_RECORDS_WITH_NO_ERROR = 'Existing',
}

export const TEAM_MEMBER_NAME_MAX_LENGTH = 50;
export const EMAIL_MAX_LENGTH = 150;

export interface ITeamMemberInfoFormData {
  userId?: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  isBillable: boolean;
  isLimitIp: boolean;
  ipAddressList: string[];
  roleId?: string;
  status?: TeamMemberStatus;
}

type IEditFormExtraFields = {
  ipAddressList?: string[];
  userImportTempId?: string;
};
export type IeditTeamMember = IEditFormExtraFields &
  Omit<ITeamMemberInfoFormData, 'isActive' | 'userId' | 'ipAddressList'>;

export interface IClientInfoFormData {
  role: string;
  roleId?: string;
  roleName?: string;
  client: string;
  clientId?: string;
  clientName?: string;
  clientPermissionGroup?: string;
  permissionGroup?: string;
  projectPermissionGroup?: string;
  permissionGroupId?: string;
  permissionGroupName?: string;
  project?: string;
  projectId?: string;
  projectName?: string;
  projPermissionGroup?: string;
  projPermissionGroupId?: string;
  workspaces?: ISelectItem[];
  budgetConsumptionEnabled?: boolean;
}

export enum AddClientInfoInputKey {
  role = 'role',
  client = 'client',
  permissionGroup = 'permissionGroup',
  projPermissionGroup = 'projPermissionGroup',
  projectPermissionGroup = 'projectPermissionGroup',
  clientPermissionGroup = 'clientPermissionGroup',
  projectGroup = 'projectGroup',
  workspaces = 'workspaces',
  projects = 'project',
  workspace = 'workspace',
}

export enum IBulkUserTableHeaders {
  name = 'name',
  nameHeader = 'Name',
  email = 'emailAddress',
  emailHeader = 'Email Address',
  role = 'userRole',
  roleHeader = 'Role',
  ipLimitAddress = 'limitIpAddress',
  limitIpAddressHeader = 'Limit IP Access',
  permissionGroup = 'permissionGroup.permissionGroupName',
  permissionGroupName = 'permissionGroupName',
  permissionGroupHeader = 'Permission Group',
  clientPermissionGroup = 'clientPermissionGroup',
  clientPermissionGroupHeader = 'Client Permission Group',
  projectPermissionGroup = 'projectPermissionGroup',
  projectPermissionGroupHeader = 'Project Permission Group',
  projectGroup = 'projects',
  projectGroupHeader = 'Project',
  workspace = 'workspaces',
  workspaceHeader = 'Workspace',
  editIcon = 'Edit-Icon',
}

export enum TeamMemberStatus {
  active = 'Active',
  inactive = 'Inactive',
  invited = 'Invited',
}

export enum SingleClientTabStatus {
  all = 'all',
  active = 'active',
  closed = 'closed',
}

export type ProjectEditFlag = {
  projectId: string;
  editMode: boolean;
};

export type AnalyticsInfo = {
  userRole: string;
  numberOfProject: string;
};

export type ITeamMemberPermissionInfo = {
  clientPermList: ItemType[];
  projPermList: ItemType[];
};

export type Workspace = {
  workspaceId: string;
  workspaceName: string;
  workspaceCode?: string;
  isDeleted?: boolean;
};

export type ProjectDetails = {
  projectId: string;
  projectName: string;
  workspaces: Workspace[];
  highlyConfidential?: boolean;
  projectPermissions?: Permission[];
  permissionGroup?: string;
  permissionGroupName?: string;
  permissionGroupId?: string;
  domainCountryCode?: string;
  dataCenterName?: string;
  countryName?: string;
  permissionCodeBudgetConsumption?: boolean;
  permissionCodeBudgetAlert?: boolean;
  manageProjectEvidence?: boolean;
  uploadRights?: boolean;
  initiateProcessingRights?: boolean;
};
